import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'questionnaire',
    component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/Questionnaire.vue'),
  },
/*
  {
    path: '*',
    name: 'Error404',
    component: () => import('@/views/Errors/Error404.vue'),
  }
*/
]

const router = new VueRouter({
  mode: 'history',
  base: (window as any).ENV_CONFIG.baseUrl as string,
  routes
})

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router
